import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { PageHero } from '../components/ui/PageHero';
import { LegalDocument } from '../components/ui/LegalDocument';
import { privacySections } from '../data/legal';
export function PrivacyPolicy() {
  usePageMeta('Privacy Policy (Draft) | Avenqor Talent Search', 'Draft privacy notice for Avenqor Talent Search, pending legal review.');
  return <>
      <PageHero eyebrow="Legal" title="Privacy Policy" intro="How Avenqor Talent Search intends to collect, use and protect personal information. This is a draft pending legal review." data-id="element-540" data-mp="1iyfjm5zit01e" />
      <LegalDocument sections={privacySections} data-id="element-541" data-mp="1984ewh80imtg" />
    </>;
}